'use client'

import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { cn } from '@/app/_lib/utils'

type SidebarActiveIndicatorItemProps = {
  active: boolean
  layoutId: string
  children: ReactNode
  className?: string
}

export function SidebarActiveIndicatorItem({
  active,
  layoutId,
  children,
  className
}: SidebarActiveIndicatorItemProps) {
  return (
    <span className={cn('relative block w-full', className)}>
      {active && (
        <motion.span
          layoutId={layoutId}
          transition={{ type: 'spring', stiffness: 500, damping: 40 }}
          className='absolute inset-y-2 -left-3 my-auto w-0.5 rounded-full bg-contentColorPrimary'
          style={{ maxHeight: '1.5rem' }}
        />
      )}
      {children}
    </span>
  )
}
